import { getFunctions, httpsCallable } from 'firebase/functions'
import { getApps } from 'firebase/app'
import { auth } from './firebase'

function getApp() {
  return getApps()[0]
}

const functions = getFunctions(getApp())

export interface GetBookDownloadUrlRequest {
  orderId: string
}

export interface GetBookDownloadUrlResponse {
  url: string
  expiresAt: string // ISO timestamp
}

/**
 * Request a fresh short-lived signed URL for a book download.
 * The Cloud Function verifies:
 *   - The user is authenticated
 *   - The order belongs to the user
 *   - The order is paid
 *   - The order contains a book line item
 * Returns a signed URL valid for ~15 minutes.
 */
export async function getBookDownloadUrl(
  orderId: string,
): Promise<GetBookDownloadUrlResponse> {
  if (!auth.currentUser) {
    throw new Error('You must be signed in to download.')
  }

  const callable = httpsCallable<
    GetBookDownloadUrlRequest,
    GetBookDownloadUrlResponse
  >(functions, 'getBookDownloadUrl')

  const result = await callable({ orderId })

  if (!result.data?.url) {
    throw new Error('Could not generate download link. Please try again.')
  }

  return result.data
}
